import * as React from 'react';

import { Form, Input, Icon } from 'semantic-ui-react';

interface Props {
	rerender: any;
	onAnswer: (value: string) => void;
	correct?: boolean;
	correctAnswer: string[];
	editingMode: boolean;
	showAnswer: boolean;
}

interface State {
	formula: string;
}

export default class PlainTextExerciseComponent extends React.Component<Props, State> {

	public constructor () {
		super();
		this.state = { formula: '' };
	}

	parseText (formula: string) {
		this.setState({formula});
	}

	renderIfIncorrect (component: React.ReactElement<any>) {
		if (this.props.correct !== false) {
			return null;
		}

		return component;
	}

	renderIfIncorrectOrShowAnswer (component: React.ReactElement<any>) {
		if (this.props.showAnswer === true) {
			return component;
		}

		return this.renderIfIncorrect(component);
	}

	renderInput () {
		if (this.props.correct !== undefined) {
			return null;
		}

		return <Input autoFocus={!this.props.editingMode} transparent spellCheck={false} fluid placeholder='Type your answer here' className='exercise-input' style={{fontFamily: 'monospace', textAlign: 'center', color: 'black'}} value={this.state.formula} onChange={(event: any) => this.parseText(event.target.value)} />;
	}

	render () {
		return (
			<Form style={{margin: '24px 0'}} onSubmit={(event: any) => { event.preventDefault(); this.props.onAnswer(this.state.formula); }}>
				<p style={{fontSize: '16px', fontFamily: 'monospace'}}>{this.props.children}</p>
				{this.renderInput()}
				<p style={{fontSize: '32px', margin: '0.5em 0', fontFamily: 'monospace', color: 'inherit'}}><span style={{color: this.props.correct === undefined ? undefined : this.props.correct ? 'green' : 'red'}}>{this.props.correct !== undefined ? <Icon name={this.props.correct ? 'check' : 'remove'} /> : null}{this.state.formula}{this.props.correct !== undefined ? <Icon style={{visibility: 'hidden'}} name={this.props.correct ? 'check' : 'remove'} /> : null}</span></p>
				{this.renderIfIncorrectOrShowAnswer(<p style={{fontSize: '32px', margin: '0.5em 0', fontFamily: 'monospace', color: 'green'}}>{this.props.correctAnswer[0]}</p>)}
			</Form>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/exercises/PlainTextExerciseComponent.tsx